import styled from '@emotion/styled';
import { colors, spacing, typography } from 'component-library';

export const RichTextList = styled.ul`
  list-style: disc;
  color: ${colors.base.black};
  ${typography.body.large};
  padding-left: ${spacing.small};
  margin-bottom: ${spacing.small};
  margin-top: ${spacing.xxsmall};
`;

export const RichTextListItem = styled.li`
  ::marker {
    color: ${colors.base.black};
  }

  :last-child {
    margin-bottom: 0;
  }
`;

export const BodyBox = styled.div`
  ${typography.body.large};
  color: ${colors.base.black};
`;
